import React from 'react';
import {Text, VStack} from '@tempo/core';
import type {TdProps} from '@components/Table/core/Td';
import Td from '@components/Table/core/Td';
import type {ProviderClaim} from '@deezer/next/services/api/Starmania/requests/claim/types';

type ProviderClaimCellProps = {
	claim: ProviderClaim;
} & TdProps;

const ProviderClaimCell = ({claim, ...rest}: ProviderClaimCellProps) => {
	const {name, upc} = claim;

	return (
		<Td whiteSpace="pre-wrap" {...rest}>
			<VStack alignItems="initial" spacing={0}>
				<Text
					noOfLines={1}
					fontWeight="semibold"
					wordBreak="break-all"
					data-testid="provider-claim-cell-title"
				>
					{name}
				</Text>
				<Text
					noOfLines={1}
					wordBreak="break-all"
					data-testid="provider-claim-cell-upc"
				>
					{upc}
				</Text>
			</VStack>
		</Td>
	);
};

export default ProviderClaimCell;
